/* ===== BACKEDSTOCK THEME - GLOBAL JS ===== */

document.addEventListener('DOMContentLoaded', function() {

  /* --- Trust Widget Counter --- */
  const counterEl = document.querySelector('[data-trust-count]');
  if (counterEl) {
    let count = parseInt(counterEl.dataset.trustCount) || 503;
    setInterval(() => {
      count += Math.floor(Math.random() * 3) + 1;
      counterEl.textContent = count;
    }, 8000);
  }

  /* --- Product Modal --- */
  const overlay = document.getElementById('productModalOverlay');
  const modal = document.getElementById('productModal');

  document.querySelectorAll('[data-open-modal]').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const card = this.closest('.product-card') || this.closest('[data-product-card]');
      if (!card) return;

      const title = card.querySelector('.product-card__title')?.textContent || '';
      const img = card.querySelector('.product-card__image')?.src || '';
      const salePrice = card.querySelector('.product-card__price--sale')?.textContent || '';
      const desc = card.dataset.description || 'Instant access to verified supplier contacts, ordering details, and sourcing guidance.';
      const url = card.dataset.productUrl || '#';

      if (modal) {
        modal.querySelector('.product-modal__title').textContent = title;
        modal.querySelector('.product-modal__price').textContent = salePrice;
        modal.querySelector('.product-modal__desc').textContent = desc;
        modal.querySelector('.product-modal__buy').href = url;
        const modalImg = modal.querySelector('.product-modal__image');
        if (modalImg && img) modalImg.src = img;
      }

      if (overlay) overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });

  // Close modal
  document.querySelectorAll('[data-close-modal]').forEach(btn => {
    btn.addEventListener('click', () => {
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = '';
    });
  });

  if (overlay) {
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        overlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }

  // ESC to close
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay?.classList.contains('active')) {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  });

  /* --- Announcement Bar Duplication for Infinite Scroll --- */
  const track = document.querySelector('.announcement-bar__track');
  if (track) {
    const clone = track.innerHTML;
    track.innerHTML = clone + clone;
  }
});
